// Side-effect-free call-signal decisions for Messenger. The component executes the returned action.
// cur = current call state (or null); pc = { exists, hasRemote, signalingState }.

export function decideSignal(msg, { threadId, cur, pc }) {
  const sig = (msg && msg.signal) || {};
  const from = msg && msg.from_user_id;
  const active = !!cur && cur.mode !== "ended";
  if (msg && msg.conv_id && msg.conv_id !== threadId) {
    if (sig.kind !== "offer" || sig.renegotiate) return { type: "ignore" };
    return active ? { type: "busy", convId: msg.conv_id } : { type: "toast_other_chat", callKind: sig.callKind || "audio" };
  }
  switch (sig.kind) {
    case "offer":
      if (sig.renegotiate) return pc.exists ? { type: "renegotiate" } : { type: "ignore" };
      if (cur && cur.mode === "incoming" && cur.from === from && cur.offer === sig.sdp) return { type: "ignore" };
      if (active) return { type: "busy", convId: threadId };
      return { type: "incoming", call: { mode: "incoming", kind: sig.callKind === "video" ? "video" : "audio", from, offer: sig.sdp } };
    case "ringing":
      return cur && cur.mode === "outgoing" ? { type: "ringing" } : { type: "ignore" };
    case "answer":
      return pc.exists && pc.signalingState === "have-local-offer" ? { type: "answer" } : { type: "ignore" };
    case "ice":
      if (!sig.candidate) return { type: "ignore" };
      return pc.exists && pc.hasRemote ? { type: "ice_add" } : { type: "ice_buffer" };
    case "hangup":
      if (!active) return { type: "ignore" };
      return { type: "end", reason: cur.mode === "incoming" ? "missed" : "ended" };
    case "decline":
      return active ? { type: "end", reason: "declined" } : { type: "ignore" };
    case "busy":
      return active ? { type: "end", reason: "busy" } : { type: "ignore" };
    default:
      return { type: "ignore" };
  }
}

// Server refused to relay a signal (Gate 3: membership / presence / rate limit).
export function decideServerError(reason, cur) {
  const r = reason === "callee_offline" ? "offline" : reason === "rate_limited" ? "rate_limited" : reason === "busy" ? "busy" : "failed";
  if (cur && (cur.mode === "outgoing" || cur.mode === "starting")) return { type: "end", reason: r };
  if (r === "rate_limited") return { type: "toast_rate_limited" };
  return { type: "ignore" };
}
